import { createSlug } from '../../utils/helpers';
import { listPublicCompanyRecords } from '../../api/companyRecords';

const SERVICES_CACHE_TTL_MS = 5 * 60_000;
const servicesCache = new Map();
const pendingFetches = new Map();

const normalizeService = (service) => {
  if (!service || service.active === false) return null;
  return service;
};

export const getCachedStorefrontServices = (companyId) => {
  if (!companyId) return null;
  const cached = servicesCache.get(companyId);
  if (!cached || Date.now() - cached.timestamp >= SERVICES_CACHE_TTL_MS) {
    return null;
  }
  return cached.services;
};

export const findCachedStorefrontServiceBySlug = (companyId, slug) => {
  const services = getCachedStorefrontServices(companyId);
  if (!services?.length || !slug) return null;
  return services.find((service) => createSlug(service.name) === slug) || null;
};

export const fetchStorefrontServices = async (companyId, { force = false } = {}) => {
  if (!companyId) return [];

  if (!force) {
    const cached = getCachedStorefrontServices(companyId);
    if (cached) return cached;
  }

  if (pendingFetches.has(companyId)) {
    return pendingFetches.get(companyId);
  }

  const promise = (async () => {
    const services = (await listPublicCompanyRecords({ companyId, kind: 'services' }))
      .map(normalizeService)
      .filter(Boolean);

    servicesCache.set(companyId, { services, timestamp: Date.now() });
    return services;
  })().finally(() => {
    pendingFetches.delete(companyId);
  });

  pendingFetches.set(companyId, promise);
  return promise;
};

export const prefetchStorefrontServices = (companyId) => {
  if (!companyId || getCachedStorefrontServices(companyId)) {
    return;
  }
  void fetchStorefrontServices(companyId);
};
